import { render, staticRenderFns } from "./UtilBadgeCount.vue?vue&type=template&id=1b9da519&scoped=true"
import script from "./UtilBadgeCount.vue?vue&type=script&lang=js"
export * from "./UtilBadgeCount.vue?vue&type=script&lang=js"
import style0 from "./UtilBadgeCount.vue?vue&type=style&index=0&id=1b9da519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9da519",
  null
  
)

export default component.exports